import { render } from "./investinfo-count.vue?vue&type=template&id=21f19df2&scoped=true"
import script from "./investinfo-count.vue?vue&type=script&lang=js"
export * from "./investinfo-count.vue?vue&type=script&lang=js"

import "./investinfo-count.vue?vue&type=style&index=0&id=21f19df2&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f19df2"]])

export default __exports__